import {useEffect} from 'react';
import wrap from 'wraptile';

export const onEffect = wrap((setMrssDefaults: any, {isLoading}:any) => {
    if (isLoading)
        setMrssDefaults();
});

const useMrssDefaults = (props: any) => {
    const {
        setMrssDefaults,
        mrssDefaults,
    } = props;
    const fetchMrssDefaults = onEffect(setMrssDefaults, mrssDefaults);
    useEffect(fetchMrssDefaults, []);
};

export default useMrssDefaults;
